export default __webpack_public_path__ + "static/media/confirmationCheck.1683b9bd.svg";